<template>
  <div class="header">
    <div class="header_title">
      <div class="header_logo">
        <!-- logo去除 2023年4月3日15:31:23-->
        <managerLogoSvg v-show="showLogo === 'true'" />
      </div>
      <div class="line"></div>
      <div class="header_title">{{ title }}</div>
    </div>
    <div class="right_btn">
      <WorkButton :title="'首页'" style="margin-right: 20px" />
      <WorkButton :title="workTitle" :url="workUrl" />
    </div>
  </div>
</template>
<script>
import managerLogoSvg from '@/assets/myImg/logo-管理平台-白色.svg?inline'
import WorkButton from '@/components/workButton/workButton'
export default {
  name: 'HeaderLayout',
  components: {
    managerLogoSvg,
    WorkButton
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    workTitle: {
      type: String || undefined,
      default: undefined
    },
    workUrl: {
      type: String || undefined,
      default: undefined
    }
  },
  data () {
    return {
      showLogo: process.env.VUE_APP_LOGO
    }
  },
  computed: {
    wrpCls () {
      return {
        'ant-pro-global-header-index-right': true,
        'ant-pro-global-header-index-light': true
      }
    }
  }
}
</script>
<style lang="less" scoped>
.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  background-image: linear-gradient(270deg, rgba(8, 144, 242, 0.5) 0%, #0890f2 100%);
  fill-opacity: 0.5;

  .header_logo {
    margin-top: 12px;
    fill-opacity: 1;
  }

  .header_title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    color: rgba(255, 255, 255, 100);
    margin-left: 26px;
    font-size: 28px;

    .line {
      margin-top: 10px;
      margin-left: 25px;
      width: 1px;
      height: 36px;
      border-left: 2px solid #ecedf1;
    }

    .header_title {
      margin-top: 10px;
      margin-left: 25px;
      font-family: CloudZongYiGBK;
      font-size: 20px;
      color: #ffffff;
      letter-spacing: 0.79px;
      font-weight: 400;
    }
  }

  .right_btn {
    margin: 20px;
  }
}
</style>
